import React from 'react';
import Reveal from './Reveal';
import { Kern } from './Kern';

export const SectionMarker = ({ index, label, className = '' }) => (
  <div className={className}>
    <span className="label !text-[var(--accent)]">{String(label).replace(/^\/\s*/, '')}</span>
  </div>
);

import { gap } from '../data';

const Gap = () => {
  return (
    <section id="studio" className="relative section-pad border-t border-[var(--border)]">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        {/* Heading + body in the left column, infographic video in the right (stacked on mobile) */}
        <div className="mt-6 md:mt-10 grid md:grid-cols-2 gap-10 md:gap-14 items-start">
          <div>
            <Reveal><SectionMarker index={gap.index} label={gap.label} className="label-gap" /></Reveal>
            <Reveal>
              <h2 className="font-display font-medium text-[clamp(1.9rem,4vw,3.4rem)] leading-[1.06] tracking-[-0.01em]">
                {gap.headline[0]}<br />
                <span className="font-serif-c text-[var(--accent)] font-normal">{gap.headline[1]}</span>
              </h2>
            </Reveal>
            <Reveal delay={120}>
              <p className="hidden text-[var(--muted)] leading-relaxed font-light text-left mt-8 md:mt-10">{gap.body.replace(/\s*Sometimes a lot\.\s*$/, '')}<br />Sometimes a lot.</p>
            </Reveal>
          </div>
          <Reveal delay={160}>
            <div className="relative rounded-xl overflow-hidden border border-[var(--border)] w-full">
              <video
                src="/gap-infographic.mp4"
                poster="/gap-infographic-poster.jpg"
                className="w-full h-auto block"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                aria-label="Idea, Space, Technology, Build, Finished Experience with three handovers"
                data-testid="gap-infographic-video"
              />
            </div>
          </Reveal>
        </div>

        <Reveal delay={120}>
          <p className="hidden font-serif-c italic text-[var(--accent)] text-[1.5rem] md:text-[2.2rem] text-center mt-[var(--section-pad)] [text-wrap:balance] w-full">{gap.kicker}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default Gap;
